import { useState } from 'react'
import {
   Menu,
   MenuList,
   MenuItem,
   ListItemText,
   Grid,
   ListItemIcon
} from '@material-ui/core'
import { MoreVert, CancelPresentation, FilterNone } from '@material-ui/icons'
import same from 'lodash/identity'
import isEqual from 'lodash/isEqual'

import { QUESTIONNAIRE } from '../../constants'
import { userSettingsModule } from 'utils/utils'
const TableMoreOptions = ({ rowData, onAction = same }) => {
   const [anchorEl, setAnchorEl] = useState(null)
   const handleShow = ({ target }) =>
      setAnchorEl(prev => (prev ? null : target))
   const handleAction = (action, value) => {
      setAnchorEl(null)
      onAction(action, value)
   }

   return (
      <>
         <MoreVert onClick={handleShow} />
         <Menu
            id={rowData?.id}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            // anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            // style={{ marginBottom: 70 }}
            onClose={handleShow}
         >
            <MenuList variant="selectedMenu" style={{ width: 150 }}>
               <ActionItem
                  Icon={FilterNone}
                  title="Duplicar"
                  onClick={() => handleAction('duplicate', rowData)}
                  disabled={
                     !userSettingsModule.buscarValorEnUserSettings(
                        'operations',
                        'DUPLICAR CUESTIONARIO'
                     )
                  }
               />
               <ActionItem
                  Icon={CancelPresentation}
                  title="Eliminar"
                  onClick={() => handleAction('delete', rowData)}
                  disabled={
                     isEqual(rowData?.status, QUESTIONNAIRE.PUBLISHED_STATUS) ||
                     !userSettingsModule.buscarValorEnUserSettings(
                        'operations',
                        'ELIMINAR CUESTIONARIO'
                     )
                  }
               />
            </MenuList>
         </Menu>
      </>
   )
}

const ActionItem = ({ Icon, title, ...props }) => (
   <MenuItem {...props}>
      <ListItemIcon>
         <Icon />
      </ListItemIcon>
      <ListItemText>{title}</ListItemText>
   </MenuItem>
)

export default TableMoreOptions
